import React, { ReactNode, useMemo } from "react"
import { MarksType } from "./blocks/ColoredBlock";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const Outer = styled.div.attrs({
    className: 'colored-marks'
})`
    display: flex;
    flex-flow: row;
    gap: 24px;

`;

export const Mark = styled.div<{ type: any, bottom?: boolean }>`
    display: flex;
    height: auto;
    place-items: flex-${({ bottom }) => bottom ? 'end' : 'start'};
    margin-bottom: ${({ bottom }) => bottom ? '50px' : '0px'};

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            svg {
                ${({ type }) => type === MarksType.type1 ? css`
                    width: 36px;
                    height: 27px;
                ` : css`
                    width: 36px;
                    height: 40px;
                `};
            }
        };

        @media (max-width: ${LayoutConst.screen.l}px) {
            svg {
                ${({ type }) => type === MarksType.type1 ? css`
                    width: 25px;
                    height: 19px;
                ` : css`
                    width: 25px;
                    height: 28px;
                `};
            }
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            margin-bottom: ${({ bottom }) => bottom ? '50px' : '0px'};
            svg {
                ${({ type }) => type === MarksType.type1 ? css`
                    width: 16px;
                    height: 12px;
                ` : css`
                    width: 16px;
                    height: 18px;
                `};
            }
        }
`;

export const MarksComponent = ({type, children}: {type: any, children: ReactNode}) => {

    const topMarkType1Svg = (
        <svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.641 42L31.7692 24.4396C33.5641 16.5948 36.3761 10.8017 40.2051 7.06034C44.0342 3.19827 49.2991 0.844824 56 0L54.3846 7.42241C50.6752 8.02586 47.6838 9.59482 45.4103 12.1293C43.1368 14.5431 41.3419 18.6465 40.0256 24.4396L34.641 23.8965H51.3333L47.2051 42H27.641ZM0 42L4.12821 24.4396C5.92308 16.5948 8.73504 10.8017 12.5641 7.06034C16.3932 3.19827 21.6581 0.844824 28.359 0L26.7436 7.42241C23.0342 8.02586 20.0427 9.59482 17.7692 12.1293C15.4957 14.5431 13.7009 18.6465 12.3846 24.4396L7 23.8965H23.6923L19.5641 42H0Z" fill="white"/>
        </svg>
    )

    const bottomMarkType1Svg = (
        <svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.641 42L29.2564 34.5776C32.9658 33.9741 35.9573 32.4655 38.2308 30.0517C40.5043 27.5172 42.2991 23.3534 43.6154 17.5603L49 18.1034H32.3077L36.4359 0H56L51.8718 17.5603C50.0769 25.2845 47.265 31.0776 43.4359 34.9397C39.6068 38.681 34.3419 41.0345 27.641 42ZM0 42L1.61538 34.5776C5.32479 33.9741 8.31624 32.4655 10.5897 30.0517C12.8632 27.5172 14.6581 23.3534 15.9744 17.5603L21.359 18.1034H4.66667L8.79487 0H28.359L24.2308 17.5603C22.4359 25.2845 19.6239 31.0776 15.7949 34.9397C11.9658 38.681 6.70086 41.0345 0 42Z" fill="white"/>
        </svg>
    )

    const topMarkType2Svg = (
        <svg width="56" height="63" viewBox="0 0 56 63" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.4161 63H15.5328L0 32.2182L0.204379 31.1922H3.06569L19.4161 63ZM29.8394 0L3.27007 32.2182L0 31.8078L0.204379 30.7818L25.7518 0H29.8394ZM45.5766 63H41.6934L26.1606 32.2182L26.365 31.1922H29.2263L45.5766 63ZM56 0L29.4307 32.2182L26.1606 31.8078L26.365 30.7818L51.9124 0H56Z" fill="white"/>
        </svg>
    )

    const bottomMarkType2Svg = (
        <svg width="56" height="61" viewBox="0 0 56 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 61L26.0932 30.0033L29.3047 30.202L29.1039 31.1954L4.01434 61H0ZM10.2366 0H13.8495L29.3047 29.8046L29.1039 30.7981H26.2939L10.2366 0ZM26.6953 61L52.7885 30.0033L56 30.202L55.7993 31.1954L30.7097 61H26.6953ZM36.9319 0H40.5448L56 29.8046L55.7993 30.7981H52.9893L36.9319 0Z" fill="white"/>
        </svg>
    )


    const {topMark, bottomMark} = useMemo(() => {
        if (type === MarksType.type1) {
            return {
                topMark: <Mark type={type}>{topMarkType1Svg}</Mark>,
                bottomMark: <Mark type={type} bottom>{bottomMarkType1Svg}</Mark>
            }
        } else if (type === MarksType.type2) {
            return {
                topMark: <Mark type={type}>{topMarkType2Svg}</Mark>,
                bottomMark: <Mark type={type} bottom>{bottomMarkType2Svg}</Mark>
            }
        }

        return {
            topMark: '',
            bottomMark: ''
        }
    }, [type])


    if (!type || type === MarksType.type3) {
        return children
    }
    return (
        <Outer>
            {topMark}
            {children}
            {bottomMark}
        </Outer>
    )
}
import React, { ReactNode, useMemo } from "react"
import { MarksType } from "./blocks/ColoredBlock";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const Outer = styled.div.attrs({
    className: 'colored-marks'
})`
    display: flex;
    flex-flow: row;
    gap: 24px;

`;

export const Mark = styled.div<{ type: any, bottom?: boolean }>`
    display: flex;
    height: auto;
    place-items: flex-${({ bottom }) => bottom ? 'end' : 'start'};
    margin-bottom: ${({ bottom }) => bottom ? '50px' : '0px'};

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            svg {
                ${({ type }) => type === MarksType.type1 ? css`
                    width: 36px;
                    height: 27px;
                ` : css`
                    width: 36px;
                    height: 40px;
                `};
            }
        };

        @media (max-width: ${LayoutConst.screen.l}px) {
            svg {
                ${({ type }) => type === MarksType.type1 ? css`
                    width: 25px;
                    height: 19px;
                ` : css`
                    width: 25px;
                    height: 28px;
                `};
            }
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
            margin-bottom: ${({ bottom }) => bottom ? '50px' : '0px'};
            svg {
                ${({ type }) => type === MarksType.type1 ? css`
                    width: 16px;
                    height: 12px;
                ` : css`
                    width: 16px;
                    height: 18px;
                `};
            }
        }
`;

export const MarksComponent = ({type, children}: {type: any, children: ReactNode}) => {

    const topMarkType1Svg = (
        <svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.641 42L31.7692 24.4396C33.5641 16.5948 36.3761 10.8017 40.2051 7.06034C44.0342 3.19827 49.2991 0.844824 56 0L54.3846 7.42241C50.6752 8.02586 47.6838 9.59482 45.4103 12.1293C43.1368 14.5431 41.3419 18.6465 40.0256 24.4396L34.641 23.8965H51.3333L47.2051 42H27.641ZM0 42L4.12821 24.4396C5.92308 16.5948 8.73504 10.8017 12.5641 7.06034C16.3932 3.19827 21.6581 0.844824 28.359 0L26.7436 7.42241C23.0342 8.02586 20.0427 9.59482 17.7692 12.1293C15.4957 14.5431 13.7009 18.6465 12.3846 24.4396L7 23.8965H23.6923L19.5641 42H0Z" fill="white"/>
        </svg>
    )

    const bottomMarkType1Svg = (
        <svg width="56" height="42" viewBox="0 0 56 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.641 42L29.2564 34.5776C32.9658 33.9741 35.9573 32.4655 38.2308 30.0517C40.5043 27.5172 42.2991 23.3534 43.6154 17.5603L49 18.1034H32.3077L36.4359 0H56L51.8718 17.5603C50.0769 25.2845 47.265 31.0776 43.4359 34.9397C39.6068 38.681 34.3419 41.0345 27.641 42ZM0 42L1.61538 34.5776C5.32479 33.9741 8.31624 32.4655 10.5897 30.0517C12.8632 27.5172 14.6581 23.3534 15.9744 17.5603L21.359 18.1034H4.66667L8.79487 0H28.359L24.2308 17.5603C22.4359 25.2845 19.6239 31.0776 15.7949 34.9397C11.9658 38.681 6.70086 41.0345 0 42Z" fill="white"/>
        </svg>
    )

    const topMarkType2Svg = (
        <svg width="56" height="63" viewBox="0 0 56 63" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.4161 63H15.5328L0 32.2182L0.204379 31.1922H3.06569L19.4161 63ZM29.8394 0L3.27007 32.2182L0 31.8078L0.204379 30.7818L25.7518 0H29.8394ZM45.5766 63H41.6934L26.1606 32.2182L26.365 31.1922H29.2263L45.5766 63ZM56 0L29.4307 32.2182L26.1606 31.8078L26.365 30.7818L51.9124 0H56Z" fill="white"/>
        </svg>
    )

    const bottomMarkType2Svg = (
        <svg width="56" height="61" viewBox="0 0 56 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 61L26.0932 30.0033L29.3047 30.202L29.1039 31.1954L4.01434 61H0ZM10.2366 0H13.8495L29.3047 29.8046L29.1039 30.7981H26.2939L10.2366 0ZM26.6953 61L52.7885 30.0033L56 30.202L55.7993 31.1954L30.7097 61H26.6953ZM36.9319 0H40.5448L56 29.8046L55.7993 30.7981H52.9893L36.9319 0Z" fill="white"/>
        </svg>
    )


    const {topMark, bottomMark} = useMemo(() => {
        if (type === MarksType.type1) {
            return {
                topMark: <Mark type={type}>{topMarkType1Svg}</Mark>,
                bottomMark: <Mark type={type} bottom>{bottomMarkType1Svg}</Mark>
            }
        } else if (type === MarksType.type2) {
            return {
                topMark: <Mark type={type}>{topMarkType2Svg}</Mark>,
                bottomMark: <Mark type={type} bottom>{bottomMarkType2Svg}</Mark>
            }
        }

        return {
            topMark: '',
            bottomMark: ''
        }
    }, [type])


    if (!type || type === MarksType.type3) {
        return children
    }
    return (
        <Outer>
            {topMark}
            {children}
            {bottomMark}
        </Outer>
    )
}
